<template>
  <div class="hero-carousel-wrap">
    <div ref="heroSwiper" class="swiper hero-swiper">
      <div class="swiper-wrapper">
        <div
          v-for="(slide, idx) in heroSlides"
          :key="$i18n.locale + '-' + idx"
          class="swiper-slide"
        >
          <div class="" :style="slide.bgStyle">
            <div class="hero-slide-overlay" />
            <div class="">
              <div class="">
                <img :src="slide.image" :alt="slide.title || ''" class="hero-product-img">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-button-prev hero-swiper-prev" />
      <div class="swiper-button-next hero-swiper-next" />
      <div class="swiper-pagination hero-swiper-pagination" />
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.mjs'
import 'swiper/swiper-bundle.css'
import { getHeroSlidesForLocale } from '@/data/heroCarouselSlides'

export default {
  name: 'HeroCarousel',
  data() {
    return {
      heroSwiperInstance: null,
    }
  },
  computed: {
    heroSlides() {
      const base = getHeroSlidesForLocale(this.$i18n.locale)
      return base.map((s, i) => ({
        ...s,
        title: this.$t(`hero.slideAlt${i + 1}`),
      }))
    },
  },
  watch: {
    '$i18n.locale'() {
      this.destroyHeroSwiper()
      this.$nextTick(() => this.initHeroSwiper())
    },
  },
  methods: {
    goDetail(id) {
      this.$router.push(`/detail/${this.heroSlides[id].id}`)
    },
    destroyHeroSwiper() {
      if (this.heroSwiperInstance) {
        try {
          this.heroSwiperInstance.destroy(true, true)
        } catch (e) {
          /* ignore */
        }
        this.heroSwiperInstance = null
      }
    },
    initHeroSwiper() {
      const el = this.$refs.heroSwiper
      if (!el || !this.heroSlides.length) return
      this.heroSwiperInstance = new Swiper(el, {
        loop: true,
        speed: 600,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        pagination: {
          el: el.querySelector('.hero-swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: el.querySelector('.hero-swiper-next'),
          prevEl: el.querySelector('.hero-swiper-prev'),
        },
      })
    },
  },
  mounted() {
    this.$nextTick(() => this.initHeroSwiper())
  },
  beforeDestroy() {
    this.destroyHeroSwiper()
  },
}
</script>

<style scoped>
.hero-carousel-wrap {
  width: 100%;
}

.hero-swiper {
  width: 100%;
  height: auto;
}

.hero-swiper ::v-deep .swiper-slide {
  height: auto;
}

.hero-slide {
  position: relative;
  height: 600px;
  width: 100%;
  background-size: cover;
  background-position: center;
}

.hero-slide-overlay {
  position: absolute;
  inset: 0;

  pointer-events: none;
}

.hero-slide-inner {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  height: 100%;
  padding: 48px 24px 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  box-sizing: border-box;
}

.hero-copy {
  flex: 1;
  min-width: 0;
  color: #fff;
}

.hero-slide-title {
  margin: 0 0 28px;
  font-size: clamp(28px, 4.5vw, 44px);
  font-weight: 800;
  letter-spacing: 0.04em;
  line-height: 1.15;
  text-shadow: 0 2px 24px rgba(0, 0, 0, 0.45);
}

.hero-features {
  margin: 0;
  padding: 0;
  list-style: none;
}

.hero-feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.02em;
  text-shadow: 0 1px 8px rgba(0, 0, 0, 0.35);
}

.hero-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #2563eb;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.35);
}

.hero-visual {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
}

.hero-product-img {
  width: 100%;
  height: 600px;
}

@media (max-width: 768px) {
  .hero-slide-inner {
    flex-direction: column;
    justify-content: center;
    padding-top: 72px;
    padding-bottom: 80px;
  }

  .hero-slide-title {
    margin-bottom: 20px;
  }

  .hero-product-img {
    max-height: 280px;
  }
}
.hero-swiper ::v-deep .swiper-button-prev{
  left: 50px;
}
.hero-swiper ::v-deep .swiper-button-next{
  right: 50px;
}
.hero-swiper ::v-deep .swiper-button-prev,
.hero-swiper ::v-deep .swiper-button-next {

  width: 48px;
  height: 48px;
  border-radius: 2px;
  background: transparent;
  color: #fff;
  margin-top: 0;
  top: 50%;
  transform: translateY(-50%);
}

.hero-swiper ::v-deep .swiper-button-prev:hover,
.hero-swiper ::v-deep .swiper-button-next:hover {
   background: transparent;
  color: #0F62EA;
}

.hero-swiper ::v-deep .swiper-button-prev::after,
.hero-swiper ::v-deep .swiper-button-next::after {
position: relative;
z-index: 1;
font-size: 25px;
font-weight: 700;
}
.hero-swiper ::v-deep .swiper-button-prev::before,
.hero-swiper ::v-deep .swiper-button-next::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  margin-left: -50%;
  margin-top: -50%;
  border-radius: 2px;
  background: rgba(80, 80, 80, 0.45);
  transform: rotate(45deg); /* 只转背景 */
  z-index: 0;
}
.hero-swiper ::v-deep .swiper-pagination {
  bottom: 20px;
}

.hero-swiper ::v-deep .swiper-pagination-bullet {
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.45);
  opacity: 1;
}

.hero-swiper ::v-deep .swiper-pagination-bullet-active {
  background: #2563eb;
  width: 17px;
  border-radius: 10px;
}
</style>
